import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@mui/material/Tooltip';
import { GridColDef } from '@mui/x-data-grid';
import { diamGridStringFilterOperators } from '../../diamGridUtils';
import { GridActionButton, StyledDeleteIcon } from '../DiamDataGrid/styles';
import {
  ModifierChip,
  ModifierChipEllipsis,
  ModifiersContainer,
} from './styles';
import { Team, TeamActionHandlers } from './types';

function formatMembersCount(count: number): string {
  return `${count} member${count === 1 ? '' : 's'}`;
}

export function buildTeamColumns({
  onEdit,
  onDelete,
}: TeamActionHandlers): GridColDef<Team>[] {
  return [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      minWidth: 180,
      filterOperators: diamGridStringFilterOperators,
    },
    {
      field: 'membersCount',
      headerName: 'Members',
      flex: 0.7,
      minWidth: 120,
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      filterable: false,
      renderCell: ({ row }) => formatMembersCount(row.membersCount),
    },
    {
      field: 'modifiers',
      headerName: 'Modifiers',
      flex: 1.5,
      minWidth: 220,
      filterable: false,
      valueGetter: (_value, row) => row.modifiers.join(', '),
      renderCell: ({ row }) => (
        <Tooltip title={row.modifiers.join(', ')}>
          <ModifiersContainer>
            {row.modifiers.map((modifier, index) => {
              const ChipComponent =
                index === 0 ? ModifierChip : ModifierChipEllipsis;

              return (
                <ChipComponent
                  key={modifier}
                  color="primary"
                  label={modifier}
                />
              );
            })}
          </ModifiersContainer>
        </Tooltip>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      align: 'center',
      cellClassName: 'actions-cell',
      filterable: false,
      getApplyQuickFilterFn: () => null,
      headerAlign: 'center',
      minWidth: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <Tooltip title="Edit">
            <GridActionButton
              aria-label={`Edit ${row.name}`}
              color="primary"
              onClick={event => {
                event.stopPropagation();
                onEdit?.(row);
              }}
            >
              <EditIcon fontSize="small" color="primary" />
            </GridActionButton>
          </Tooltip>
          <Tooltip title="Delete">
            <GridActionButton
              aria-label={`Delete ${row.name}`}
              onClick={event => {
                event.stopPropagation();
                onDelete?.(row);
              }}
            >
              <StyledDeleteIcon />
            </GridActionButton>
          </Tooltip>
        </>
      ),
    },
  ];
}
